<template>
  <!-- 로그인 팝업 -->
  <div class="popup_mask" @click="loginClosePopupMask">
    <div id="login_popup" class="popup_area">
      <div class="popup_inner">
        <div class="popup_box">
          <div class="popup_logo">
            <img src='@/assets/img/winner_pc/main/logo.png' />
          </div>
          <div class="popup_input">
            <p><i><img src="@/assets/img/winner_pc/main/icon_id.png" alt="" /></i><input type="text" id="mb_id" name="mb_id" :placeholder="$t('front.common.memId')" v-model="model.memId" @keyup.enter="onSubmit" /></p>
            <p><i><img src="@/assets/img/winner_pc/main/icon_password.png" alt="" /></i><input type="password" id="mb_password" name="mb_password" :placeholder="$t('front.common.password')" v-model="model.memPass" @keyup.enter="onSubmit" /></p>
            <p class="save_id"><input type="checkbox" id="save_id" v-model="saveId"><label for="save_id">{{ $t('front.login.saveID') }}</label></p>
            <div class="d-f_1">
              <button type="button" @click.prevent="onSubmit">{{ $t('front.login.loginButton') }}</button>
              <button type="button" @click="goSignup">{{ $t('front.common.signup') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { memberMixin } from '@/mixin/member';
export default {
  name: 'Signin',
  mixins: [memberMixin],
  methods: {
    goSignup() {
      console.log('goSignup');
      this.$emit('close', 'join');
    }
  }
}
</script>
